var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import AppContainer from "@irati/ui/src/AppContainer";
import authentication from "@irati/auth";
import { LangLoader } from "@irati/utils/lang";
import { NestedRoute, PartialRoute, withPartialRoute } from "@irati/utils/history/routing";
import { PERKS } from "@irati-web/app/src/routeConfig";
import HomePageV2 from "../screens/HomePageV2";
import HomeScreen from "../screens/Home";
import EditHomePage from "../screens/EditHomePage";
var HomeRoutes = /** @class */ (function (_super) {
    __extends(HomeRoutes, _super);
    function HomeRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HomeRoutes.prototype.render = function () {
        var path = this.props.path;
        var isCultureHubEnabled = authentication.apps("platform.cultureHub");
        return (React.createElement(React.Fragment, null,
            !isCultureHubEnabled && React.createElement(NestedRoute, { path: "/home", component: HomeScreen, useGrid: false }),
            isCultureHubEnabled && (React.createElement(LangLoader, { bucket: PERKS },
                React.createElement(AppContainer, null,
                    React.createElement(NestedRoute, { exact: true, path: "/home", component: HomePageV2, useGrid: false }),
                    React.createElement(PartialRoute, { permissions: "admin", match: path, path: "/edit", component: EditHomePage, title: "Edit Home Page" }))))));
    };
    return HomeRoutes;
}(Component));
export default withPartialRoute(HomeRoutes);
